<template>
  <div>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin congue
    vehicula dolor vel volutpat. In sagittis diam vel risus malesuada lobortis.
    Praesent suscipit elementum lectus, non molestie augue pharetra eu. Class
    aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos
    himenaeos. Etiam quis consequat mi. Aliquam erat volutpat. Orci varius
    natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
    Pellentesque habitant morbi tristique senectus et netus et malesuada fames
    ac turpis egestas. Nulla ullamcorper est dui, ut sagittis leo dictum vel.
    Cras ut maximus nulla
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
};
</script>